import { useToast } from 'src/hooks';
import { useEventContext } from '../../provider';
import { useCartStore, useCheckoutStore, useDiscountStore } from '../../stores';
import { useEffect, useRef } from 'react';
import { AxiosError } from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { useMeQuery } from 'src/hooks/queries/user';
import { useNavigatePreservingQueryParams } from 'src/hooks/useNavigateWithQueryParams';

/**
 *
 * O hook é responsável por verificar se a pessoa está na rota de pagamento e se possui ingressos no carrinho.
 * Se não houver ingresso no carrinho o hook fará um redirect para página de seleção de ingressos
 *
 * @hook
 * @param isPaymentRoute type: boolean. Default = false
 */
export const useProtectPaymentRoute = (isPaymentRoute = false) => {
  const { eventID } = useParams();
  const location = useLocation();

  const { queryNavigation } = useNavigatePreservingQueryParams();

  const { openOrEditSell } = useEventContext();

  const { clearDiscount } = useDiscountStore();

  const { getEventCheckout } = useCheckoutStore();
  const checkout = getEventCheckout(eventID!);

  const toast = useToast();

  const meQuery = useMeQuery();

  const { getEventCart } = useCartStore();

  const hasCalledOpenOrEditSell = useRef(false);


  useEffect(() => {
    (async () => {
      const hasTicketsOnCart = getEventCart(eventID!)?.some(
        item => item.quantity > 0,
      );

      if (!isPaymentRoute) return;
      if (!hasTicketsOnCart || (!meQuery.isLoading && !meQuery.data?.email)) {
        queryNavigation(`tickets`);

        toast({
          description: 'Adicione pelo menos um ingresso para prosseguir',
        });
      } else if (!checkout.sellId || !hasCalledOpenOrEditSell.current) {
        try {
          hasCalledOpenOrEditSell.current = true;
          await openOrEditSell();
        } catch (er) {
          clearDiscount();
          queryNavigation(location.pathname);
          toast({
            description:
              (er as AxiosError).message ?? 'Ocorreu um erro inesperado',
            status: 'warning',
          });
        }
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkout.sellId, clearDiscount, eventID, getEventCart, isPaymentRoute, location.pathname, openOrEditSell, toast]);
};